import { Event, FilterAlt, Person, RestartAlt, Search } from '@mui/icons-material';
import {
	Autocomplete,
	Box,
	InputAdornment,
	Paper,
	TextField,
	Typography,
} from '@mui/material';
import { IndicacaoUsuarioBusca } from '../../../services/indicacao';
import { IndicacaoButton } from './IndicacaoButton';

interface FilterToolbarProps {
	dataInicio: string;
	dataFim: string;
	onChangeInicio: (value: string) => void;
	onChangeFim: (value: string) => void;
	isAdmin: boolean;
	usuarioSelecionado: IndicacaoUsuarioBusca | null;
	opcoesUsuario: IndicacaoUsuarioBusca[];
	buscandoUsuario: boolean;
	usuarioPlaceholder: string;
	onOpenUsuario: () => void;
	onInputUsuario: (value: string, reason: string) => void;
	onChangeUsuario: (usuario: IndicacaoUsuarioBusca | null) => void;
	onFiltrar: () => void;
	onLimpar: () => void;
}

export function FilterToolbar({
	dataInicio,
	dataFim,
	onChangeInicio,
	onChangeFim,
	isAdmin,
	usuarioSelecionado,
	opcoesUsuario,
	buscandoUsuario,
	usuarioPlaceholder,
	onOpenUsuario,
	onInputUsuario,
	onChangeUsuario,
	onFiltrar,
	onLimpar,
}: FilterToolbarProps) {
	return (
		<Paper
			elevation={0}
			sx={{
				p: { xs: 1.5, sm: 2 },
				borderRadius: 3,
				border: '1px solid #f1f5f9',
			}}
		>
			<Box
				display="grid"
				gridTemplateColumns={{
					xs: '1fr',
					md: 'auto minmax(170px, 200px) minmax(170px, 200px) minmax(180px, 1fr) auto auto',
				}}
				gap={1.5}
				alignItems="center"
			>
				<Box display={{ xs: 'none', md: 'flex' }} alignItems="center" gap={1} pr={0.5}>
					<FilterAlt sx={{ fontSize: 18, color: 'text.secondary' }} />
					<Typography fontSize="0.8rem" fontWeight={700} color="text.secondary">
						Filtros
					</Typography>
				</Box>
				<TextField
					label="Data inicial"
					type="date"
					size="small"
					value={dataInicio}
					onChange={(event) => onChangeInicio(event.target.value)}
					InputLabelProps={{ shrink: true }}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<Event sx={{ fontSize: 18, color: 'text.secondary' }} />
							</InputAdornment>
						),
					}}
				/>
				<TextField
					label="Data final"
					type="date"
					size="small"
					value={dataFim}
					onChange={(event) => onChangeFim(event.target.value)}
					InputLabelProps={{ shrink: true }}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<Event sx={{ fontSize: 18, color: 'text.secondary' }} />
							</InputAdornment>
						),
					}}
				/>
				<Autocomplete
					size="small"
					disabled={!isAdmin}
					options={isAdmin ? opcoesUsuario : []}
					value={isAdmin ? usuarioSelecionado : null}
					loading={buscandoUsuario}
					filterOptions={(options) => options}
					getOptionLabel={(option) => option.nome}
					isOptionEqualToValue={(option, value) => option.id === value.id}
					noOptionsText="Nenhum usuário encontrado"
					loadingText="Buscando..."
					onOpen={onOpenUsuario}
					onInputChange={(_, value, reason) => onInputUsuario(value, reason)}
					onChange={(_, value) => onChangeUsuario(value)}
					renderOption={(props, option) => {
						const { key, ...optionProps } = props;
						return (
							<li key={key} {...optionProps}>
								<Box minWidth={0}>
									<Typography fontSize="0.9rem" noWrap>
										{option.nome}
									</Typography>
									{option.email ? (
										<Typography fontSize="0.75rem" color="text.secondary" noWrap>
											{option.email}
										</Typography>
									) : null}
								</Box>
							</li>
						);
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							label="Usuário"
							placeholder={usuarioPlaceholder}
							InputProps={{
								...params.InputProps,
								startAdornment: (
									<>
										<InputAdornment position="start">
											<Person sx={{ fontSize: 18, color: 'text.secondary' }} />
										</InputAdornment>
										{params.InputProps.startAdornment}
									</>
								),
							}}
						/>
					)}
				/>
				<IndicacaoButton label="Filtrar" icon={<Search />} onClick={onFiltrar} />
				<IndicacaoButton
					label="Limpar"
					icon={<RestartAlt />}
					variant="outlined"
					onClick={onLimpar}
				/>
			</Box>
		</Paper>
	);
}
